var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"8"}},[_c('h2',{staticClass:"text-lg-h3"},[_vm._v(" "+_vm._s(_vm.institutional.title)+" ")])])],1),_c('v-row',{staticClass:"mt-10",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"8"},domProps:{"innerHTML":_vm._s(_vm.institutional.text)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }